/**
 * Format an error for display in the UI
 * Handles Error objects, strings, and other types
 */
export function formatError(error: unknown): string {
	if (error instanceof Error) {
		const parts = [`Name: ${error.name}`, `Message: ${error.message}`];

		if (error.stack) {
			parts.push(`Stack:\n${error.stack}`);
		}

		return parts.join("\n\n");
	}

	if (typeof error === "string") {
		return error;
	}

	try {
		return JSON.stringify(error, null, 2);
	} catch {
		return String(error);
	}
}
